import dayjs from 'dayjs';

import Button from 'components/field/Button';
import Alert from 'components/global/Alert';
import Image from 'components/global/Image';
import Typography from 'components/global/Typography';

import * as S from './OTOLinkBuyer.styled';

const PaymentSuccessful = ({ paymentMethod, currency, data, showTrackingOrder }) => (
	<S.ResultContainer>
		<S.Card padding={0} background border={0} shadowed rounded>
			<S.SuccessWrapper>
				<Image
					url={
						paymentMethod === 'CC'
							? 'https://storage.googleapis.com/tryoto-public/public/assets/icons/OTO-link/payment-success.svg'
							: 'https://storage.googleapis.com/tryoto-public/public/assets/icons/OTO-link/boxes-success.svg'
					}
					width="19rem"
					height="100%"
				/>

				<S.SuccessInfoContainer>
					<Typography variant="p1" fontWeight="700" noWrap>
						{paymentMethod === 'CC'
							? 'otoLinkPaymentCompletedSuccessfully'
							: 'otoLinkOrderHasBeenPlacedSuccessfully'}
					</Typography>
					<Typography variant="p3" color="var(--content-3)" noWrap>
						{paymentMethod === 'CC' ? 'otoLinkSuccessCreditCardPayment' : 'otoLinkSuccessCODPayment'}
					</Typography>
				</S.SuccessInfoContainer>

				{paymentMethod === 'CC' && (
					<Alert content="otoLinkYourPaymentSecurelyHeld" variant="warning" showIcon />
				)}

				<S.OrderSummary>
					<OrderRow label="orderId" value={data?.orderId} />
					<OrderRow label="orderDate" value={dayjs(data?.orderDate).utc().format('DD MMMM YYYY')} />
					<OrderRow label="totalAmount" value={data?.amount || 0} currency={currency} />
				</S.OrderSummary>
				<Button label="otoLinkTrackYourOrder" onClick={showTrackingOrder} />
			</S.SuccessWrapper>
		</S.Card>
	</S.ResultContainer>
);

const OrderRow = ({ label, value, currency }) => (
	<S.OrderSummaryRow>
		<Typography variant="p2" color="var(--black-40)" fontWeight="500">
			{label}
		</Typography>
		<Typography variant="p2" color="var(--black)" fontWeight="500" withCurrency={!!currency} currency={currency}>
			{value}
		</Typography>
	</S.OrderSummaryRow>
);

export default PaymentSuccessful;
